var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "app-default-layout",
      attrs: {
        "aria-live": "polite",
        id: "focus-target"
      }
    },
    [
      !_vm.session_ready
        ? [_c("preloader")]
        : [
            _c("app-header"),
            _c(
              "v-main",
              {
                attrs: {
                  evelation: "0"
                }
              },
              [
                _c(
                  "v-container",
                  {
                    staticClass: "pt-0 pb-16 mb-16 px-md-10 px-sm-3",
                    attrs: {
                      fluid: ""
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "mb-6"
                      },
                      [_c("user-block")],
                      1
                    ),
                    _c(
                      "transition",
                      {
                        attrs: {
                          name: "router-anim",
                          "enter-active-class": "animated ".concat(
                            _vm.routerAnimation
                          )
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "gg-container"
                          },
                          [
                            _vm.banned
                              ? _c("ban-alert", {
                                  staticClass: "mb-3"
                                })
                              : _vm._e(),
                            _c("router-view")
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }